module.exports = __webpack_public_path__ + "img/start_2.c147ed4c.svg";